import { useContract } from './useContract'

import useEnvConfig from 'hooks/useEnvConfig'
import { ABI_COCOS_POWER, ABI_LAUNCHPAD_CONTROLLER, ABI_LAUNCHPAD_POOL } from '../utils/abis'
import { useEffect, useState } from 'react'
import { useWeb3React } from '@web3-react/core'
import { formatUnits } from 'ethers/lib/utils'

export default function useVipLevel() {
  const envConfig = useEnvConfig()
  const contract = useContract(envConfig.ADDRESS_COCOS_LAUNCHPAD_CONTROLLER, ABI_LAUNCHPAD_CONTROLLER)
  const powerContract = useContract(envConfig.ADDRESS_COCOS_POWER, ABI_COCOS_POWER)
  const { account } = useWeb3React()
  const [level, setLevel] = useState(1)
  const [power, setPower] = useState(0)
  useEffect(() => {
    if (contract && powerContract) {
      powerContract.balanceOf(account).then((power) => {
        setPower(+(+formatUnits(power, 18)).toFixed(4))
        contract.getVipLevel(power).then((level) => {
          setLevel(+level + 1)
        }, [])
      })
    }
  }, [contract, powerContract, account])
  return { level, power }
}

export function useXVipLevel(contractAddress: string | undefined) {
  const [xLevel, setXLevel] = useState(1) // igo快照等级
  const { account } = useWeb3React()
  const poolContract = useContract(contractAddress, ABI_LAUNCHPAD_POOL)

  useEffect(() => {
    if (poolContract && account) {
      poolContract._userVipLevels(account).then((res) => setXLevel(+res))
    }
  }, [poolContract, account])

  return xLevel
}
